import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.boundKeyHandler = this.handleKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeyHandler)
    document.body.style.overflow = ""
  }

  open(event) {
    if (event) event.preventDefault()
    if (!this.hasModalTarget) return
    this.modalTarget.classList.add("is-open")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.boundKeyHandler)
  }

  close(event) {
    if (event) event.preventDefault()
    if (!this.hasModalTarget) return
    this.modalTarget.classList.remove("is-open")
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.boundKeyHandler)
  }

  closeOnOverlay(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
